<template>
    <div class="mask">
        <div class="GoHmTipPage">
            <div class="tip">温馨提示</div>
            <div class="close" @click="closeMethod">x</div>
            <div class="content">
                <div class="line1"><span class="dot"></span>请使用华贸新代订舱下单<br>http://booking.ctsfreight.com<a
                        href="http://booking.ctsfreight.com" target="_blank">点击跳转</a>新网站下单</div>
                <div class="line2"><span class="dot"></span>当前网站于9月8号进行<span class="bold">全面升级</span></div>
            </div>
            <div class="button" @click="closeMethod">
                我知道了
            </div>
            <img :src="tipIcon" alt="" class="imgTip">
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            tipIcon: require('@/assets/images/login_imgs/tipIcon.png'),
        }
    },
    methods: {
        closeMethod() {
            console.log('11-1-1-1-')
            this.$emit('close')
        }
    }
}
</script>

<style scoped lang="scss">
.mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;

}

.GoHmTipPage {
    background: url("../../../assets/images/login_imgs/tipBc.png") no-repeat;
    width: 485px;
    height: 259px;
    padding: 24px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .tip {
        font-weight: bold;
        font-size: 24px;
        color: rgba(0, 0, 0, 0.88);
        line-height: 29px;

    }

    .close {
        position: absolute;
        color: #FFFFFF;
        right: 18px;
        top: 18px;
        cursor: pointer;
    }

    .content {
        font-weight: 400;
        font-size: 14px;
        color: #3D3D3D;
        line-height: 20px;
        margin-top: 32px;
        position: relative;
        z-index: 3;

        .dot {
            width: 6px;
            height: 6px;
            background: #1677FF;
            display: inline-block;
            border-radius: 50%;
            margin-right: 5px;
            position: relative;
            top: -2px;
        }
    }

    .line1 {
        margin-bottom: 16px;

        a {
            color: #1677FF;
            cursor: pointer;
        }
    }

    .line2 {
        .bold {
            color: #000000;
            font-weight: 600;

        }
    }

    .button {
        width: 123px;
        height: 32px;
        background: #1677FF;
        box-shadow: 0px 2px 4px 0px rgba(22, 119, 255, 0.4);
        border-radius: 21px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        line-height: 32px;
        margin: 0 auto;
        margin-top: 44px;
        position: relative;
        z-index: 3;
        cursor: pointer;
    }

    img.imgTip {
        width: 358px;
        position: absolute;
        top: 32px;
        left: 238px;
    }
}
</style>
